import { FC, ReactNode } from 'react';

interface Props {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}

export const WrapperBlock: FC<Props> = ({
  title,
  children,
  actions = null,
}) => {
  return (
    <div className='flex flex-col gap-3'>
      <div className='flex justify-between items-center'>
        <h4 className='font-heading text-heading-sm'>{title}</h4>
        {actions}
      </div>
      <div>{children}</div>
    </div>
  );
};
